import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Toaster } from 'react-hot-toast';

// Ana Bileşenler
import Header from './components/Header';
import Footer from './components/Footer';
import AdminRoute from './components/AdminRoute';
import EditorRoute from './components/EditorRoute';
import ProfileCompletedRoute from './components/ProfileCompletedRoute';
import ScrollToTop from './components/ScrollToTop';

// Kullanıcı Sayfaları
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import OnboardingPage from './pages/OnboardingPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import ReadingPage from './pages/ReadingPage'; // Okuma Sayfası
// import ArticlesPage from './pages/ArticlesPage'; // Eski sayfayı kaldırıyoruz
import NewsPage from './pages/NewsPage';         // YENİ
import ResearchPage from './pages/ResearchPage'; // YENİ
import InfoPage from './pages/InfoPage';         // YENİ
import ArticleDetailPage from './pages/ArticleDetailPage';
import QuizPage from './pages/QuizPage';
import VerifyCertificatePage from './pages/VerifyCertificatePage';
import ProfilePage from './pages/ProfilePage'; // ProfilePage import'unu eklemeyi unutmuşuz
import SettingsPage from './pages/SettingsPage'; // Settings Page
import AviationAIPage from './pages/AviationAIPage'; // Aviation AI Page

// Admin ve Editör Sayfaları
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminUserListPage from './pages/admin/AdminUserListPage';
import AdminCourseListPage from './pages/admin/AdminCourseListPage';
import CourseAddPage from './pages/admin/CourseAddPage';
import CourseEditPage from './pages/admin/CourseEditPage';
import AdminQuizListPage from './pages/admin/AdminQuizListPage';
import AdminQuizAddPage from './pages/admin/AdminQuizAddPage';
import AdminQuizEditPage from './pages/admin/AdminQuizEditPage';
import ArticleListPage from './pages/editor/ArticleListPage';
import ArticleAddPage from './pages/editor/ArticleAddPage';
import ArticleEditPage from './pages/editor/ArticleEditPage';
import AdminContactListPage from './pages/admin/AdminContactListPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';

function AppRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public Rotalar */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/courses/:id" element={<CourseDetailPage />} />
        <Route path="/courses/:id/read/:pageNumber" element={<ReadingPage />} /> {/* Okuma rotası */}
        {/* <Route path="/articles" element={<ArticlesPage />} /> */} {/* Eski rotayı kaldırıyoruz */}
        <Route path="/news" element={<NewsPage />} />         {/* YENİ */}
        <Route path="/research" element={<ResearchPage />} /> {/* YENİ */}
        <Route path="/info" element={<InfoPage />} />         {/* YENİ */}
        <Route path="/articles/:id" element={<ArticleDetailPage />} />
        <Route path="/quiz/:id" element={<QuizPage />} />
        <Route path="/verify/" element={<VerifyCertificatePage />} />
        <Route path="/verify/:certId" element={<VerifyCertificatePage />} />
        <Route path="/aviation-ai" element={<AviationAIPage />} />
        <Route path="/profile" element={<ProfilePage />} /> {/* ProfilePage rotası */}
        <Route path="/settings" element={<SettingsPage />} /> {/* Settings Page */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/about" element={<AboutPage />} />


        {/* Editör & Admin Rotaları */}
        <Route path="/editor/articles" element={<EditorRoute><ArticleListPage /></EditorRoute>} />
        <Route path="/editor/add-article" element={<EditorRoute><ArticleAddPage /></EditorRoute>} />
        <Route path="/editor/edit-article/:id" element={<EditorRoute><ArticleEditPage /></EditorRoute>} />

        {/* Sadece Admin Rotaları */}
        <Route path="/admin" element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminUserListPage /></AdminRoute>} />
        <Route path="/admin/courses" element={<AdminRoute><AdminCourseListPage /></AdminRoute>} />
        <Route path="/admin/add-course" element={<AdminRoute><CourseAddPage /></AdminRoute>} />
        <Route path="/admin/edit-course/:id" element={<AdminRoute><CourseEditPage /></AdminRoute>} />
        <Route path="/admin/quizzes" element={<AdminRoute><AdminQuizListPage /></AdminRoute>} />
        <Route path="/admin/add-quiz" element={<AdminRoute><AdminQuizAddPage /></AdminRoute>} />
        <Route path="/admin/edit-quiz/:id" element={<AdminRoute><AdminQuizEditPage /></AdminRoute>} />
        <Route path="/admin/contacts" element={<AdminRoute><AdminContactListPage /></AdminRoute>} />
        
        {/* 404 routes */}
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AnimatePresence>
  );
}

// App component'i artık Router'ı içermiyor
function App() {
  return (
    <>
      <Toaster 
        position="top-right" 
        toastOptions={{
          className: 'dark:bg-dark-card dark:text-dark-text',
        }}
      />
      <ProfileCompletedRoute>
        <div className="bg-light-bg dark:bg-dark-bg text-light-text dark:text-dark-text min-h-screen font-sans flex flex-col">
          <Header />
          <motion.main 
              className="flex-grow"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
          >
            <AppRoutes />
          </motion.main>
          <Footer />
        </div>
      </ProfileCompletedRoute>
    </>
  );
}

// Router sarmasını index.js'ten buraya taşıdık, App.js'in son hali bu.
function WrappedApp() {
  return (
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  )
}

export default WrappedApp;